module.exports = __webpack_public_path__ + "src/assets/img/page6/d83d6e49de62edb61e112d960f85e70e.png";